import { Link, useLocation } from 'react-router-dom';
import { Flex, Image, Text } from '@chakra-ui/react';
import ListOn from '../assets/Icon/32px/gamelist/active=on.svg';
import ListOff from '../assets/Icon/32px/gamelist/active=off.svg';
import ActivityOn from '../assets/Icon/32px/mysch/active=on.svg';
import ActivityOff from '../assets/Icon/32px/mysch/active=off.svg';
import MyOn from '../assets/Icon/32px/profile/active=on.svg';
import MyOff from '../assets/Icon/32px/profile/active=off.svg';

const Navigation = () => {
  const { pathname } = useLocation();
  return (
    <Flex
      py="8px"
      justify="space-around"
      borderTop="1px solid #D5D5D5"
      position="fixed"
      bottom="0"
      left="0"
      right="0"
    >
      <Link to="/">
        <Flex flexDir="column" alignItems="center">
          <Image src={pathname === '/' ? ListOn : ListOff} />
          <Text fontSize="10px" fontWeight="semibold">
            모임 목록
          </Text>
        </Flex>
      </Link>
      <Link to="/activity">
        <Flex flexDir="column" alignItems="center">
          <Image src={pathname === '/activity' ? ActivityOn : ActivityOff} />
          <Text fontSize="10px" fontWeight="semibold">
            내 활동
          </Text>
        </Flex>
      </Link>
      <Link to="/my">
        <Flex flexDir="column" alignItems="center">
          <Image src={pathname === '/my' ? MyOn : MyOff} />
          <Text fontSize="10px" fontWeight="semibold">
            My
          </Text>
        </Flex>
      </Link>
    </Flex>
  );
};

export default Navigation;
